import { render, staticRenderFns } from "./setClinic.vue?vue&type=template&id=6ad63c35&scoped=true"
import script from "./setClinic.vue?vue&type=script&lang=js"
export * from "./setClinic.vue?vue&type=script&lang=js"
import style0 from "./setClinic.vue?vue&type=style&index=0&id=6ad63c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad63c35",
  null
  
)

export default component.exports